module.exports = __webpack_public_path__ + "static/media/54728425_587108031775817_2878639699147096064_o.0b4c5db8.jpg";